import { SxProps, Theme } from '@mui/material/styles';

export const newMostTitleSX = (isHref: boolean): SxProps<Theme> => ({
	textTransform: 'uppercase',
	mb: { xs: '0px', sm: '0' },
	cursor: isHref ? 'pointer' : 'default',
});
